const formModal = document.getElementById('inc-form-modal');
if (formModal) {
    const titleEl     = document.getElementById('inc-form-modal-label');
    const contactText = document.getElementById('inc-form-modal-contact-text');
    const buildText   = document.getElementById('inc-form-modal-build-text');

    // data-form-context="build" (set on the "Build This Floorplan" buttons in
    // masterplan_detail_inc.html / plan_detail_inc.html) swaps the headline and
    // body copy to the build-floorplan messaging. Every other trigger across the
    // site (nav, subnav, location/spec pages, etc.) has no such attribute, so
    // the modal falls back to its default "Contact Expert" content unchanged.
    formModal.addEventListener('show.bs.modal', (event) => {
        const trigger = event.relatedTarget;
        const isBuild = trigger && trigger.dataset.formContext === 'build';

        if (titleEl) titleEl.textContent = isBuild ? 'Build This Floorplan' : 'Contact Expert';

        if (contactText && buildText) {
            contactText.classList.toggle('d-none', isBuild);
            buildText.classList.toggle('d-none', !isBuild);
        }
    });
}
